export default __webpack_public_path__ + "static/media/login-icon-white.d77805fd.svg";